import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Toast, { ToastTypes } from 'components/ToastNotify';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from 'storybook-mui/build/components/Button';
import Icon from 'storybook-mui/build/components/Icon';
import { IconTypes } from 'storybook-mui/build/components/IconTypes';
import IconButtonComponent from 'storybook-mui/build/components/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Modal from 'storybook-mui/build/components/Modal';
import BadgeComponent from 'storybook-mui/build/components/Badge';
import { ReloadLayout } from 'reducers/Layout/LayoutActions';
import { showLoading } from 'reducers/Alerts/AlertActions';
import { clear, getUser, setUser, siteConfigConstants } from 'api/AxiosManager';
import copy from 'copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CryptoJS from 'crypto-js';

import {
	addLoginHistoryInClient,
	fetchOrganizationInfoById,
	GetOrganisationOfUser,
	logout,
} from 'firebaseApis/authentication';
import AvatarComponent from 'storybook-mui/build/components/Avatar';
import {
	ClearNotifications,
	GetNotifications,
	UpdateCampaignsUnReadCount,
	UpdateReceivedNote,
	//	UpdateSocialUnReadCount,
} from 'firebaseApis/socialmedia';
import { fetchFirestoreDocFromMasterDB } from 'firebaseApis/common';

import { getDateFormat, getDateTimeWithUnix } from 'helpers/Formats';
import { UpdateCampaignDetails } from 'firebaseApis/single_channel_campaigns';
import { RootStore } from 'reducers';
import { delay } from 'helpers/utils';
import LinearProgressBar from 'components/LinearProgressBar';
import Version from './Version';

export function WelcomeUser() {
	let isUnmount = false;
	const [orgData, setOrgData] = useState<any>([]);
	const [notificationData, setNotificationData] = useState<any>([]);
	const [userName, setUserName] = useState<string>('');
	const [count, setCount] = useState<number>(0);
	const [showOrganisationsModal, setShowOrganisationsModal] =
		useState<boolean>(false);
	const [clearNotifications, setClearNotifications] = useState<boolean>(false);
	const [anchorUserMenuEl, setAnchorUserMenuEl] =
		React.useState<null | HTMLElement>(null);
	const [anchorNotifyEl, setAnchorNotifyuEl] =
		React.useState<null | HTMLElement>(null);
	const userMenu = Boolean(anchorUserMenuEl);
	const notifyMenu = Boolean(anchorNotifyEl);
	const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorUserMenuEl(event.currentTarget);
	};
	const handleNotifyClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorNotifyuEl(event.currentTarget);
	};
	const layoutStore = useSelector((state: RootStore) => state.layoutReducer);
	const [loading, setLoading] = useState<boolean>(false);
	const [currentProgress, setCurrentProgress] = useState<number>(0);
	const [versionModalOpen, setVersionModalOpen] = useState<boolean>(false);

	const dispatch = useDispatch();
	const history = useHistory();
	const user = getUser();
	const logOut = async () => {
		dispatch(showLoading());
		const data = {
			orgId: user.organisationPathFirebase,
			userId: user.userId,
			ip: user.ip,
			city: user.city,
			userRegistrationType: 'N/A',
			authenticationType: 'N/A',
			Event: 'Sign Out',
		};
		await addLoginHistoryInClient(data);
		const logoutUrl = siteConfigConstants().REACT_APP_LOGOUT_REDIRECT_URL;
		clear();
		window.location.replace(`${logoutUrl}/logout`);
	};

	const getData = async () => {
		const docPath = `Users/${user.userId}`;
		const res: any = await fetchFirestoreDocFromMasterDB(docPath);
		const resultData = await GetOrganisationOfUser(user.userId);
		setUser({
			...user,
			profilePic: res?.profilePic || '',
		});
		const name = `${getUser()?.fName?.charAt(0)?.toUpperCase()}${getUser()
			?.lName?.charAt(0)
			?.toUpperCase()}`;
		if (!isUnmount) {
			setUserName(name);
			setOrgData(resultData);
		}
		dispatch(ReloadLayout(false));
	};

	const selectOrganisation = async (id: any) => {
		try {
			setShowOrganisationsModal(false);
			setLoading(true);
			const response = await fetchOrganizationInfoById(id);

			setCurrentProgress(100);
			await delay(300);
			setLoading(false);
			const { userObj, siteConfig } = response;
			if (userObj.organizationName && userObj.organisationPathFirebase) {
				const token = {
					user: response.userObj,
					expiration: new Date().getTime() + 60 * 1000, // token will expire in 60 secs
				};
				const encryptedToken = CryptoJS.AES.encrypt(
					JSON.stringify(token),
					'LEAP360'
				).toString();
				if (siteConfig.ORGANIZATION_ASSOCIATED_WITH_DOMAIN) {
					let url = `${siteConfig.ORGANIZATION_ASSOCIATED_WITH_DOMAIN}/redirectFromLeap360?authenticationToken=${encryptedToken}`;
					if (window.location.hostname === 'dev.leap360.com') {
						url = `https://dev.leap360.com:3000/redirectFromLeap360?authenticationToken=${encryptedToken}`;
					}
					clear();
					window.location.replace(url);
				} else {
					window.location.replace(
						`${siteConfig.REACT_APP_LOGOUT_REDIRECT_URL}/createOrg`
					);
				}
			} else {
				throw new Error('Something went wrong');
			}
		} catch (error) {
			Toast({
				title: 'Session expired. Please login back.',
				type: ToastTypes.ERROR,
			});
			setLoading(false);
			logOut();
		}
	};

	const getNotes = async () => {
		const result = await GetNotifications(getUser()?.userId);
		if (!result) {
			logout();
			if (window.location.hostname === 'dev.leap360.com') {
				history.push('/');
			}
		}
		if (!isUnmount) {
			setNotificationData(result);
			setCount(result?.length);
		}

		dispatch(ReloadLayout(false));
	};
	useEffect(() => {
		getData();
		return () => {
			isUnmount = true;
		};
	}, []);

	useEffect(() => {
		if (layoutStore.Reload_Layout === true) {
			getNotes();
		}
	}, [layoutStore.Reload_Layout]);

	const navigateToTaskView = async (val) => {
		const payload = {
			Is_Read: true,
		};
		if (!val?.type) {
			history.push(`/Inbox/Received/Task/Edit/${val?.id}`);
			UpdateReceivedNote(payload, getUser()?.userId, val?.id, val?.Note_Id);
			//	UpdateSocialUnReadCount(getUser()?.userId, -1);
		} else {
			history.push(`/Inbox/Campaigns/ApprovalPending`);
			await UpdateCampaignDetails(payload, val?.campaignId);
			await UpdateCampaignsUnReadCount(getUser()?.userId, -1);
		}
		dispatch(ReloadLayout(true));
	};

	const clearAllNotifications = async () => {
		setClearNotifications(!clearNotifications);
		await ClearNotifications(getUser()?.userId);
		await UpdateCampaignsUnReadCount(getUser()?.userId, -count);
		dispatch(ReloadLayout(true));
	};
	const copyToClipBoard = () => {
		if (user?.login) {
			copy(user?.login);
			Toast({ title: 'Login Copied !', type: ToastTypes.SUCCESS });
		}
	};
	const copyIdToClipBoard = () => {
		if (user?.userId) {
			copy(user?.userId);
			Toast({ title: 'UserId Copied !', type: ToastTypes.SUCCESS });
		}
	};
	const copyUserNameToClipBoard = () => {
		const userFullName = `${user?.fName} ${
			user?.fName === user?.lName ? '' : user?.lName
		}`;
		copy(userFullName);
		Toast({ title: 'User Name Copied !', type: ToastTypes.SUCCESS });
	};

	const onVersionModalClick = (event) => {
		if ((event.ctrlKey || event.metaKey) && event.altKey && event.button === 0) {
			// fires when user presses ctrl + alt + click or command + alt + click
			setVersionModalOpen(true);
		}
	};
	return (
		<>
			<Modal
				title={
					<h1 className='uppercase text-secondary-500 text-xl text-center'>
						Versions details
					</h1>
				}
				modalId='version'
				content={<Version />}
				open={versionModalOpen}
				setOpen={() => setVersionModalOpen(false)}
				closeIcon
			/>
			{loading && (
				<LinearProgressBar
					delay={8000}
					incrementBy={1}
					currentProgress={currentProgress}
					message='Switching Organization...'
				/>
			)}
			{orgData.length > 0 && (
				<Modal
					modalId='switch-org'
					open={showOrganisationsModal}
					setOpen={() => setShowOrganisationsModal(!showOrganisationsModal)}
					closeIcon
					title={
						<h1 className='uppercase text-secondary-500 text-xl text-center'>
							Switch Organization
						</h1>
					}
					size='md'
					content={
						<>
							<div className='grid justify-center md:grid-cols-2 grid-cols-1 gap-6'>
								{orgData
									.filter(
										(orgInfo) => orgInfo.Organization_Id !== user.organisationPathFirebase
									)
									.map((org: any, index) => (
										<div
											key={index}
											className='px-6 py-2 rounded-md border-gray-300 hover:border-primary-600 border cursor-pointer w-86 bg-white hover:shadow-inner'
											onClick={() => selectOrganisation(org.Organization_Id)}
										>
											<h1 className='text-lg font-bold text-gray-500 text-center hover:text-primary-600'>
												{org.Org_Name}
											</h1>
										</div>
									))}
							</div>
						</>
					}
				/>
			)}
			<div className='flex justify-end items-center gap-2'>
				{getUser()?.organisationPathFirebase && (
					<IconButtonComponent
						id='notification'
						ariaLabel='notification'
						onClick={handleNotifyClick}
						size='large'
						content={
							<BadgeComponent
								content={<NotificationsIcon />}
								id='notification-count'
								count={notificationData?.length}
							/>
						}
					/>
				)}
				<IconButtonComponent
					id='usermenu'
					ariaLabel='usermenu'
					onClick={handleUserMenuClick}
					size='large'
					content={
						<>
							{user?.profilePic ? (
								<img
									alt=''
									className='rounded-full'
									src={user?.profilePic}
									width='30'
									height='30'
								/>
							) : (
								<AccountCircle />
							)}
						</>
					}
				/>
				<Menu
					id='user-menu'
					anchorEl={anchorUserMenuEl}
					open={userMenu}
					onClose={() => setAnchorUserMenuEl(null)}
					onClick={() => setAnchorUserMenuEl(null)}
					PaperProps={{
						elevation: 0,
						sx: {
							overflow: 'visible',
							filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
							mt: 1.5,
							'& .MuiAvatar-root': {
								width: 32,
								height: 32,
								ml: -0.5,
								mr: 1,
							},
							'&:before': {
								content: '""',
								display: 'block',
								position: 'absolute',
								top: 0,
								right: 14,
								width: 10,
								height: 10,
								bgcolor: 'background.paper',
								transform: 'translateY(-50%) rotate(45deg)',
								zIndex: 0,
							},
						},
					}}
					transformOrigin={{ horizontal: 'right', vertical: 'top' }}
					anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				>
					<MenuItem divider sx={{ cursor: 'default' }}>
						<div className='flex flex-col items-end justify-end text-sm gap-2'>
							<div className='flex items-end'>
								<Icon icon={IconTypes.Person} className='mr-1 text-sm' />
								<p className='text-gray-600 text-xl font-bold leading-5 mr-2'>
									{user?.fName} {user?.lName}
								</p>
								<ContentCopyIcon
									className='text-gray-600'
									onClick={copyUserNameToClipBoard}
								/>
							</div>
							{user?.login && (
								<div className='flex items-end'>
									{/* <Icon icon={IconTypes.Email} className='mr-1 text-xs' /> */}
									<small className='text-tiny font-semibold mr-1'>LOGIN</small>
									<p className='italic text-base py-1 leading-5 mr-2'>{user?.login}</p>
									<ContentCopyIcon className='text-gray-500' onClick={copyToClipBoard} />
								</div>
							)}

							{user?.userId && (
								<div className='flex items-end'>
									<small className='text-tiny font-semibold mr-1'>ID</small>
									<p className='italic text-base py-1 leading-5 mr-2'>{user?.userId}</p>
									<ContentCopyIcon
										className='text-gray-500'
										onClick={copyIdToClipBoard}
									/>
								</div>
							)}
							<div className='flex items-end' onClick={onVersionModalClick}>
								<small className='text-tiny font-semibold mr-1'>Version: 1.4.4.4</small>
							</div>
						</div>
					</MenuItem>
					<div className='flex flex-col'>
						{orgData.length > 1 && (
							<MenuItem
								onClick={() => {
									getData();
									setShowOrganisationsModal(true);
								}}
							>
								<span className='text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900'>
									Switch Organization
								</span>
							</MenuItem>
						)}
						<MenuItem
							onClick={() => {
								history.push('/UserSettings/MyProfile/View');
							}}
						>
							<span className='text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900'>
								User Settings
							</span>
						</MenuItem>
						<MenuItem
							onClick={() => {
								history.push('/Admin/Configurations/Billing/Dashboard');
							}}
						>
							<span className='text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900'>
								Billing & Cost Management
							</span>
						</MenuItem>
					</div>

					<hr />
					<MenuItem>
						<span
							className='text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full'
							onClick={logOut}
						>
							Log out
						</span>
					</MenuItem>
				</Menu>
				<div className='notification-list-box'>
					<Menu
						id='notification-menu'
						anchorEl={anchorNotifyEl}
						open={notifyMenu}
						onClose={() => setAnchorNotifyuEl(null)}
						onClick={() => setAnchorNotifyuEl(null)}
						PaperProps={{
							elevation: 0,
							sx: {
								overflow: 'visible',
								width: {
									sm: '100%',
									lg: '50%',
								},
								filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
								mt: 1.5,
								'& .MuiAvatar-root': {
									width: 32,
									height: 32,
									ml: -0.5,
									mr: 1,
								},
								'&:before': {
									content: '""',
									display: 'block',
									position: 'absolute',
									top: 0,
									right: 14,
									width: 10,
									height: 10,
									bgcolor: 'background.paper',
									transform: 'translateY(-50%) rotate(45deg)',
									zIndex: 0,
								},
							},
						}}
						transformOrigin={{ horizontal: 'right', vertical: 'top' }}
						anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
					>
						<div className='justify-end'>
							<Button
								onClick={() => clearAllNotifications()}
								title='Clear notifications'
								variant='text'
							/>
						</div>

						{notificationData?.map((item, index) => (
							<div key={index}>
								<MenuItem divider sx={{ whiteSpace: 'pre-wrap' }}>
									<div className='flex items-start gap-2'>
										<AvatarComponent
											id='notify-alt'
											alt='notify-alt'
											content={
												<p className='text-sm font-bold'>
													{item?.type === undefined
														? `${item?.User_First_Name?.charAt(
																0
														  )?.toUpperCase()}${item?.User_Last_Name?.charAt(
																0
														  )?.toUpperCase()}`
														: userName}
												</p>
											}
											sx={{ width: '2rem', height: '2rem', mr: 2 }}
										/>
										<div className='flex flex-col gap-1 flex-1'>
											<div className='flex items-center'>
												<p
													className='text-gray-700 text-lg font-semibold mr-2 underline'
													onClick={() => navigateToTaskView(item)}
												>
													{item?.type
														? `${item?.Campaign_Name} campaign is waiting for your approval`
														: `${item?.User_First_Name} ${item?.User_Last_Name} assigned a task to you`}
												</p>
												<p className='text-gray-400 text-sm'>
													{item?.type
														? getDateTimeWithUnix(item?.Unix_Timestamp, 'MM/DD/YYYY hh:mm a')
														: `${getDateFormat(
																item?.Created_Date_Time,
																'MM/DD/YYYY hh:mm a'
														  )}`}
												</p>
											</div>
											<p className='text-gray-500'>
												{item?.type ? item?.Description : item?.Text}
											</p>
										</div>
									</div>
								</MenuItem>
							</div>
						))}
						{notificationData?.length === 0 && (
							<div className='my-3 mx-3'>
								<h1>No Notifications </h1>
							</div>
						)}
					</Menu>
				</div>
			</div>
		</>
	);
}

export default WelcomeUser;
